import type { IconNode } from '../types';

/**
 * @name apple-core
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMmEyIDIgMCAwIDAtMiAydjIuNTMiIC8+CiAgPHBhdGggZD0iTTEyIDYuNTNhNS45OCA1Ljk4IDAgMCAwLTguNS41IDQgNCAwIDAgMSA0LjAyIDUuODYgNCA0IDAgMCAxLTEuNzYgNy4wNEM2LjgyIDIxLjE3IDcuOTcgMjIgOSAyMmMxLjUgMCAxLjUtMSAzLTFzMS41IDEgMyAxYzEuMDMgMCAyLjE4LS44MyAzLjI0LTIuMDdhNCA0IDAgMCAxLTEuNzYtNy4wMyA0IDQgMCAwIDEgNC4wMi01Ljg3IDUuOTkgNS45OSAwIDAgMC04LjUtLjVaIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/apple-core
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const appleCore: IconNode = [
  ['path', { d: 'M14 2a2 2 0 0 0-2 2v2.53', key: 'zcfq28' }],
  [
    'path',
    {
      d: 'M12 6.53a5.98 5.98 0 0 0-8.5.5 4 4 0 0 1 4.02 5.86 4 4 0 0 1-1.76 7.04C6.82 21.17 7.97 22 9 22c1.5 0 1.5-1 3-1s1.5 1 3 1c1.03 0 2.18-.83 3.24-2.07a4 4 0 0 1-1.76-7.03 4 4 0 0 1 4.02-5.87 5.99 5.99 0 0 0-8.5-.5Z',
      key: 'xkop6i',
    },
  ],
];

export default appleCore;
